/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable, ApplicationRef } from '@angular/core';
import { IceNavService } from '../../../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { BaseAppService } from '../../../../projects/icemedx-lib/src/services/baseapp.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';
import { Router } from '@angular/router';
import { IcecontrolPermission } from '../../../icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../../icemedx-lib/src/login/login.config';

@Injectable()
export class AppService extends BaseAppService {

  constructor(navSvc: IceNavService, domainSvc: DomainService, loginSvc: LoginService, app: ApplicationRef) {
    super(navSvc, domainSvc, loginSvc, app);
  }

  public defaultMenus() {
    super.defaultMenus();
    let navSvc: IceNavService = super.getNavService();
    let curActType: IceTypes.ACCOUNT_TYPE = this.getCurrentAccountType();

    let accountingBar = this.addBreadcrumbToolbar("AccountingToolbar");
    if (accountingBar != null) {
      let menuItems: any[] = [
        { display: "Open", permission: new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaReadOnly), active: true, id: "root", link: "" },
      ];

      accountingBar.items.push({
        display: "GL/Journal Entry",
        menuitem: "appMenu1",
        data: null,
        domain: this.getCurrentAccount(),
        domaintype: curActType,
        link: "accounting/ledger",
        properties: {
          class: { "fas": true, "fa-book-open": true, "fa-3x": true },
          color: 'blue'
        }
      });

      accountingBar.items.push({
        display: "Reports",
        menuitem: "appMenu1",
        data: null,
        domain: this.getCurrentAccount(),
        domaintype: curActType,
        link: "reports",
        properties: {
          class: { "fas": true, "fa-chart-pie": true, "fa-3x": true },
          color: 'orange'
        }
      });

      accountingBar.items.push({
        display: "History of Charges",
        menuitem: "appMenu1",
        data: null,
        domain: this.getCurrentAccount(),
        domaintype: curActType,
        link: "accounting/servicechargehistory",
        properties: {
          class: { "fas": true, "fa-history": true, "fa-3x": true },
          color: 'orange'
        }
      });
      accountingBar["appMenu1"] = { menuItems: menuItems };
    }

    if (this.getMainAppChildMode() == false) {
      navSvc.insertSideRoute(null, "dashboard", null, "dashboard", "Dashboard", "fas fa-tachometer-alt", 0);
      let ptact: string = this.getCurrentPatient();
      let domain: string = this.getCurrentAccount();

      let loginSvc = this.getLoginService();
      let usrInfo = loginSvc.GetSessionUserInfo();

      this.homeMenu();

      switch (curActType) {
        case IceTypes.ACCOUNT_TYPE.actFacility:
        case IceTypes.ACCOUNT_TYPE.actProvider:
        case IceTypes.ACCOUNT_TYPE.actPharmacy:
        case IceTypes.ACCOUNT_TYPE.actPayer:{
          navSvc.insertSideRoute(null, "accounting", null, "accounting/summary", "Accounting", "fas fa-money-bill", 0);
          navSvc.insertSideRoute(null, "ledger", null, "accounting/ledger", "Ledgers/Journals", "fas fa-book-open", 0);
          navSvc.insertSideRoute(null, "servicecharge", null, "accounting/serviceitemcharge/0", "Service Checkout", "fas fa-shopping-cart", 0);
          navSvc.insertSideRoute(null, "servicechargehistory", null, "accounting/servicechargehistory", "Service Charge History", "fas fa-history", 0);
          navSvc.insertSideRoute(null, "claimshistory", null, "accounting/claimshistory", "Claims History", "fas fa-landmark", 0);
          navSvc.insertSideRoute(null, "paytohistory", null, "accounting/paytohistory", "Pay To History", "fas fa-file-alt", 0);
          navSvc.insertSideRoute(null, "inventory", null, "accounting/inventory", "Inventory", "fas fa-warehouse", 0);
          navSvc.insertSideRoute(null, "billtemplates", null, "accounting/billingtemplates", "Billing Templates", "fas fa-list-alt", 0);
          navSvc.insertSideRoute(null, "reports", null, "reports", "Reports", "fas fa-chart-pie", 0);
          //navSvc.insertSideRoute(null, "todolist", null, "todolist", "To-Do List", "fas fa-list-ol", 0, "ToDoList");
          break;
        }
      }
    } else {
      navSvc.showTopMenuParent(navSvc.topMenuMessagesParentElementID, false);
      navSvc.showTopMenuParent(navSvc.topMenuLogoutParentElementID, false);
    }
  }
}
